module.exports = __webpack_public_path__ + "static/media/DSA Pre 1.db4a3974.jpg";